import { apiRequest } from '../../../../shared/api/index.js';

export const markPaymentSeen = async (id: string): Promise<void> => {
  await apiRequest<void>(`/payments/${id}/seen`, { method: 'POST' });
};
